import api from "@/lib/api";

const META_KEY = "panel_base_path";
const SID_KEY = "admin_sid";

let cache = null;
let loading = null;

function readStoredBase() {
  try {
    return localStorage.getItem(META_KEY) || "";
  } catch {
    return "";
  }
}

export function persistPanelBase(base) {
  try {
    if (base) localStorage.setItem(META_KEY, base);
  } catch {
    /* ignore */
  }
}

export async function loadPanelMeta(force = false) {
  if (cache && !force) return cache;
  if (loading && !force) return loading;
  loading = api
    .get("/content/panel-meta")
    .then(({ data }) => {
      cache = {
        base_path: data.base_path || "/admin",
        secret_required: Boolean(data.secret_required),
        session_minutes: Number(data.session_minutes) || 30,
      };
      persistPanelBase(cache.base_path);
      loading = null;
      return cache;
    })
    .catch(() => {
      const stored = readStoredBase();
      cache = {
        base_path: stored || "/admin",
        secret_required: false,
        session_minutes: 30,
      };
      loading = null;
      return cache;
    });
  return loading;
}

export function getPanelMeta() {
  if (cache) return cache;
  const stored = readStoredBase();
  return {
    base_path: stored || "/admin",
    secret_required: false,
    session_minutes: 30,
  };
}

export function clearPanelMetaCache() {
  cache = null;
}

export function getAdminSessionId() {
  try {
    return sessionStorage.getItem(SID_KEY) || "";
  } catch {
    return "";
  }
}

export function createAdminSessionId() {
  const sid =
    (typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID().replace(/-/g, "")
      : `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`) + Math.random().toString(36).slice(2, 8);
  try {
    sessionStorage.setItem(SID_KEY, sid);
  } catch {
    /* ignore */
  }
  return sid;
}

export function clearAdminSessionId() {
  try {
    sessionStorage.removeItem(SID_KEY);
  } catch {
    /* ignore */
  }
}

export function adminBase() {
  return getPanelMeta().base_path || "/admin";
}

export function adminLoginPath(secret) {
  const base = adminBase();
  if (secret) return `${base}/login/${secret.split("/").map(encodeURIComponent).join("/")}`;
  return `${base}/login`;
}

/** Stable panel paths — no session token in URL (avoids 404 on navigation). */
export function adminPath(sub = "") {
  const base = adminBase();
  if (!sub) return base;
  return `${base}/${String(sub).replace(/^\//, "")}`;
}
